import { convertLocalDateTimeString } from 'components/Common/Utils/DateUtils';
import {
    displayShippers,
    formatEventTypes,
    formatStringList
} from 'components/SharingAgreementsReport/fetchSharingAgreementsReport';
import { csvEscape } from 'components/SharingAgreementsReport/exportSharingAgreementsReportCsv';
import { titleStatus } from './sharingRequestModel';

const formatDate = (value) =>
    value ? convertLocalDateTimeString(String(value).replace('Z', '')) : '';

const typeFromVersion = (item) => {
    const version = String(item?.version || '')
        .trim()
        .toLowerCase();
    if (version === 'v1') {
        return 'Connection (legacy)';
    }
    if (version === 'v2') {
        return 'Sharing Agreement';
    }
    return '';
};

export const VISIBILITY_SHARING_CSV_COLUMNS = [
    { label: 'Carrier', getValue: (item) => item.carrierName || item.carrierAccountId || '' },
    { label: 'Type', getValue: typeFromVersion },
    {
        label: 'Status',
        getValue: (item) => titleStatus(item.status) || item.status || ''
    },
    { label: 'Group', getValue: (item) => item.groupName || '' },
    { label: 'Event types', getValue: (item) => formatEventTypes(item.eventTypes) },
    { label: 'Shippers', getValue: (item) => formatStringList(displayShippers(item.shippers)) },
    { label: 'References', getValue: (item) => formatStringList(item.references) },
    { label: 'Valid from', getValue: (item) => formatDate(item.validFrom) },
    { label: 'Valid to', getValue: (item) => formatDate(item.validTo) },
    { label: 'Direction', getValue: (item) => item.direction || '' }
];

export const buildVisibilitySharingCsv = (items) => {
    const header = VISIBILITY_SHARING_CSV_COLUMNS.map((column) => csvEscape(column.label)).join(
        ','
    );
    const rows = (items || []).map((item) =>
        VISIBILITY_SHARING_CSV_COLUMNS.map((column) => csvEscape(column.getValue(item))).join(',')
    );
    return [header, ...rows].join('\r\n');
};

export const visibilitySharingCsvFilename = (status) => {
    const slug = String(status || 'all')
        .trim()
        .toLowerCase();
    return `sharing-agreements-${slug}.csv`;
};

export const downloadVisibilitySharingCsv = (items, status) => {
    const csv = `\uFEFF${buildVisibilitySharingCsv(items)}`;
    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = visibilitySharingCsvFilename(status);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
};
